import atob from 'atob'
import btoa from 'btoa'

export const generateGlobalId = (typeName, id) => {
  return btoa(`${typeName}:${id}`)
}

const splitGlobalId = id => {
  return atob(id).split(':')
}

export const decodeGlobalId = id => {
  return splitGlobalId(id)[1]
}

export const getTypename = id => {
  return splitGlobalId(id)[0]
}
